import { ref, computed } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useBajaEmails(emailFromQuery) {
    const email = ref(emailFromQuery || '');

    const baja = ref(false);
    const loading = ref(false);
    const captchaToken = ref(null);
    const sitekey = process.env.VUE_APP_CLOUDFLARE_SITE_KEY;

    const canSubmit = computed(() => !!captchaToken.value && !loading.value);

    const onCaptchaVerified = token => {
        captchaToken.value = token;
    };

    /**
     * Turnstile tokens expire while the user is still on the page, and the
     * widget also reports hard errors. Both must invalidate the stored token,
     * or canSubmit would stay true and the form would submit a stale token.
     */
    const onCaptchaInvalid = () => {
        captchaToken.value = null;
    };

    /**
     * Clears the stored token without touching the widget: after a failed
     * attempt the backend has consumed the token, so the view must hand the
     * user a fresh challenge (widget reset is the view's responsibility).
     */
    const clearCaptcha = () => {
        captchaToken.value = null;
    };

    const darDeBaja = async() => {
        if (!canSubmit.value) return { ok: false };

        loading.value = true;

        const payload = {
            filters: {
                tid: store.getters.getConfig && store.getters.getConfig.hash_teatro
            },
            email: email.value,
            captchaToken: captchaToken.value
        };

        try {
            await store.dispatch(config.getVuexAlias('emails.baja'), payload);
            baja.value = true;
            return { ok: true };
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[useBajaEmails] Error al dar de baja el email:', error);
            }
            return { ok: false };
        } finally {
            loading.value = false;
        }
    };

    return {
        email,
        baja,
        loading,
        captchaToken,
        sitekey,
        canSubmit,
        onCaptchaVerified,
        onCaptchaInvalid,
        clearCaptcha,
        darDeBaja
    };
}
